import { RETREAT_PLACE } from '@/components/enc/retreat';
import { SubscribeLayout } from '@/components/enc/subscribe-layout';
import { buttonVariants } from '@/components/ui/button';
import { date } from '@/lib/date';
import { useEvent } from '@/services/events';
import { CheckCircle2 } from 'lucide-react';
import { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Page = () => {
  const { data: nextEvent } = useEvent('next');
  const { state } = useLocation() as { state?: { name?: string } };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  const day = nextEvent ? date(nextEvent.startDate).format('DD [de] MMMM') : null;

  return (
    <SubscribeLayout event={nextEvent}>
      <section className="mx-auto max-w-[720px] px-6 pt-[72px] pb-24">
        <div className="flex flex-col items-start gap-5 rounded-[24px] border border-[rgba(11,11,12,.10)] bg-white p-[clamp(28px,5vw,56px)]">
          <span className="flex size-14 items-center justify-center rounded-full bg-[#FBEDEC]">
            <CheckCircle2 className="size-7 text-brand" />
          </span>
          <h2 className="m-0 font-display text-[clamp(28px,3.4vw,40px)] leading-[1.1] font-extrabold tracking-[-0.03em] text-ink">
            {state?.name ? `Inscrição recebida, ${state.name}.` : 'Inscrição recebida.'}
          </h2>
          <p className="m-0 text-base leading-[1.7] text-[#4A4A4F]">
            Vocês estão a um passo de viver o Enchei-vos.
            {day
              ? ` Nos vemos em ${day}, no ${RETREAT_PLACE}.`
              : ` Nos vemos no ${RETREAT_PLACE}.`}
          </p>
          <div className="flex flex-wrap gap-3">
            <Link className={buttonVariants({ size: 'lg' })} to="/">
              Voltar ao site
            </Link>
            <Link
              className={buttonVariants({ size: 'lg', variant: 'outline' })}
              to="/inscricao"
            >
              Inscrever outro casal
            </Link>
          </div>
        </div>
      </section>
    </SubscribeLayout>
  );
};

export default Page;
